import BaseService from './base';
import request from '@/utils/request';
export interface ThemeViewModel {
  id?: number;
  type?: number;
  title?: string;
  introduce?: string;
  isHome?: number;
  userID?: string;
  createTime?: Date;
  lastModifyTime?: Date;
}

export default class ThemeService extends BaseService<ThemeViewModel> {
  protected serviceApi: string = 'Theme';

  get NewModel(): ThemeViewModel {
    return {
      type: 0,
      isHome: 0,
      title: '',
      introduce: '',
    };
  }

  public UpdateIsHome(id: number) {
    return request({
      url: this.serviceApi + '/UpdateIsHome',
      method: 'put',
      data: {id: id},
    });
  }
  public GetTheme() {
    return this.GetUrl('/GetTheme');
  }
  public GetSubject() {
    return this.GetUrl('/GetSubject');
  }
  public GetCaliber() {
    return this.GetUrl('/GetCaliber');
  }
  public GetHomeTheme() {
    return this.GetUrl('/GetHomeTheme/1');
  }
  public GetHomeSubject() {
    return this.GetUrl('/GetHomeTheme/0');
  }
}
